//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.UVMapping.js";
import "../GeometricUtilities/GeometricUtilities.UVMapping.SelectUVMeshObjectData.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[1,"Transformer",0,"GeometricUtilities.TransformerData",0]],[[["selectionData"],"SetTransformerToObject",{},1,0],[["canAlignToUDirection"],"SetUAxisDirection",{},1,0],[["canAlignToVDirection"],"SetVAxisDirection",{},1,0]],[]];
SPLM.GeometricUtilities.UVMapping.UVMeshManipulatorData = class extends SPLM.GeometricUtilities.UVMapping.SelectUVMeshObjectData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.UVMapping.UVMeshManipulatorData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.UVMapping.UVMeshManipulatorData.ObjectSelectionData = class{
    constructor(selectedObject,selectionPosition,viewDirection,isSnappedPosition){
        this.selectedObject=selectedObject;this.selectionPosition=selectionPosition;this.viewDirection=viewDirection;this.isSnappedPosition=isSnappedPosition;}
    get Selectedobject(){return this.selectedObject}
    set Selectedobject(val){this.selectedObject = val}
    get Selectionposition(){if(this.selectionPosition === undefined) this.selectionPosition = new SPLM.Point3d(); return this.selectionPosition}
    set Selectionposition(val){this.selectionPosition = val}
    get Viewdirection(){if(this.viewDirection === undefined) this.viewDirection = new SPLM.Vector3d(); return this.viewDirection}
    set Viewdirection(val){this.viewDirection = val}
    get Issnappedposition(){return this.isSnappedPosition}
    set Issnappedposition(val){this.isSnappedPosition = val}
};

export default SPLM;